module.exports = __webpack_public_path__ + "media/images/email_3-ff9c348d147e54feccb421c4ffa943ab.jpg";